
export const meetings = {
  title: "Személyes találkozás",
  subtitle: "Élő beszélgetés és közös élmény",
  description: "Találkozzunk személyesen! Válassz a különböző élmények közül.",
  options: {
    title: "Válassz személyes találkozás típust",
    description: "Személyes találkozásra invitállak! Válaszd ki az igényeidnek legmegfelelőbb csomagot!",
    budapest: {
      title: "Személyes látogatás Budapesten",
      description: "40 perces beszélgetés, fotózkodás, extra ajándékkal",
      features: [
        "40 perces személyes beszélgetés",
        "Közös fotózkodás",
        "Bocs Tesó ajándék (bögre, kulacs vagy póló) Fanni aláírásával",
        "Egyeztetett időpontban és helyszínen Budapesten"
      ]
    },
    outOfBudapest: {
      title: "Személyes látogatás Budapesten kívül",
      description: "40 perces beszélgetés, fotózkodás, extra ajándékkal",
      features: [
        "40 perces személyes beszélgetés",
        "Közös fotózkodás",
        "Bocs Tesó ajándék (bögre, kulacs vagy póló) Fanni aláírásával",
        "Egyeztetett időpontban és helyszínen vidéken"
      ]
    },
    candy: {
      title: "Közös vattacukor készítés",
      description: "Egyél velem egy vattacukrot az egyik gépünknél",
      features: [
        "10 perces személyes beszélgetés",
        "Közös fotózkodás",
        "Vattacukor készítés és kóstolás",
        "Kizárólag hétköznap (Duna Plaza, World Mall, Árkád Budapest)"
      ]
    }
  },
  form: {
    title: "rendelése",
    subtitle: "Tölts ki az űrlapot a személyes találkozó lefoglalásához",
    fields: {
      name: "Teljes név",
      email: "Email cím",
      phone: "Telefonszám",
      preferredDates: "Preferált időpontok",
      notes: "Egyéb megjegyzések"
    },
    placeholders: {
      name: "Add meg a neved",
      email: "Add meg az email címed",
      phone: "Add meg a telefonszámod",
      preferredDates: "Írj néhány neked megfelelő időpontot (pl. 2023. október 15-20 között hétköznap délután, vagy december elején hétvégén)",
      notes: "Ha van bármilyen egyéb kérésed vagy megjegyzésed, itt leírhatod"
    }
  }
};
